import { render, staticRenderFns } from "./govermentcenter.vue?vue&type=template&id=952ec5f0&"
import script from "./govermentcenter.vue?vue&type=script&lang=js&"
export * from "./govermentcenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports